import React from "react";

function ReadOnlyField({ label, value, fallback = "Not defined", formatter }) {
  let displayValue = value;
  if (formatter && value) {
    displayValue = formatter(value);
  }
  if (displayValue === undefined || displayValue === null || displayValue === "") {
    displayValue = fallback;
  }

  return (
    <div className="flex flex-col">
      {label && <span className="text-xs text-gray-400 mb-1">{label}</span>}
      <span className="text-sm text-gray-400">{displayValue}</span>
    </div>
  );
}

export default ReadOnlyField;
